// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"97":"9f6f6dcd","222":"7b518368","264":"5c0a1296","291":"6175d37f","603":"94199c77","661":"b315b9e8","924":"7e2c27fd"}[chunkId] + ".chunk.js";
};